import { trackEventAndOmitTypeName } from './trackEventAndOmitTypeName';

export interface MapInteractionEventData {
  schema: string;
  data: {
    event_name: string;
    interaction_type: string;
    in_page_source: string;
  };
}

export const trackMapInteraction = (eventData: MapInteractionEventData): void => {
  trackEventAndOmitTypeName(eventData);
};
